<script setup>
// eslint-disable-next-line no-unused-vars
import {BToastOrchestrator} from "bootstrap-vue-next";
import {useToastController} from "bootstrap-vue-next";
import { watch } from 'vue'
import { useStore } from 'vuex'
import i18n from '../i18n'

const store = useStore()
const { create } = useToastController()

watch(
    () => store.state.success,
    (value) => {
      if (value) {
        value.forEach(message => {
          if (message !== 'event_not_live') {
            create({
              title: i18n.global.t(message),
              body: '',
              variant: 'success',
              solid: true,
              pos: 'top-center',
              value: 3000,
            })
          }
        })
      }
    }
)

watch(
    () => store.state.errors,
    (errors) => {
      if (errors && errors.length) {
        errors.forEach(message => {
          create({
            title: i18n.global.t(message),
            body: '',
            variant: 'danger',
            solid: true,
            pos: 'top-center',
            value: 3000,
          })
        })
      }
    }
)
</script>

<template>
  <BToastOrchestrator />
</template>

<style scoped>

</style>